// extracted by mini-css-extract-plugin
export default {"SliderWrapper":"Slider_SliderWrapper__BxMvP","SwiperSlide":"Slider_SwiperSlide__t04xc"};